import {
    scrollbar,
    notifications,
    dropdown,
    connectivityCheck,
    GoogleAds,
    ContentNavigation,
    reCAPTCHA,
    dragAndDrop,
    pointerDragAndDrop,
    StepByStep,
    Topbar,
    BingoDropdown,
} from './components';

import { BrowserDetector } from './compatibility-detection/index';
import SaveToList from './components/Contents/General/SaveToList';

import { registerApplicationDirectives } from './directives';

require('./registerEvents');
require('./registerWorker');
require('./analyticsListeners');
require('./sentry');

window.BrowserDetector = BrowserDetector;
window.Components = { scrollbar,
    notifications,
    dropdown,
    connectivityCheck,
    GoogleAds,
    ContentNavigation,
    dragAndDrop,
    pointerDragAndDrop,
    SaveToList,
    reCAPTCHA,
    StepByStep,
    Topbar,
    BingoDropdown,
};

registerApplicationDirectives();

